import React, { Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { searchFacetChange } from '../Actions/FacetedSearch.action';

const RangeSlider = (props) => {

    const dispatch = useDispatch();
    useEffect(() => {
        let slider = document.getElementById(props.id);
        noUiSlider.create(slider, {
            start: props.value.indexOf(undefined) <= 0 ? ([props.value[0], props.value[1]]) : props.start,
            connect: props.connect,
            step: props.step,
            orientation: 'horizontal',
            range: props.range,
            format: props.format,
            tooltips: [true, true],
        });
        slider.noUiSlider.on('end', handleSliderChange);
    }, [props]);

    const handleSliderChange = (values, handle, unencoded, tap, positions, noUiSlider) => {
        props.group.options[0].id = Math.round(unencoded[0]) + "-" + Math.round(unencoded[1]);
        dispatch(searchFacetChange(props.group, props.group.options[0]));        
    }


    return (
        <div className="faceted-search__slider-container">
            <div id={props.id} className="slider"></div>
        </div>
    )
}


export default RangeSlider;
